module.exports = __webpack_public_path__ + "static/media/oven-state-2.c0de4b25.wav";